import { render, staticRenderFns } from "./ItemTable.vue?vue&type=template&id=293e756e"
import script from "@/components/item-table/ItemTable.ts?vue&type=script&lang=ts&external"
export * from "@/components/item-table/ItemTable.ts?vue&type=script&lang=ts&external"
import style0 from "@/components/item-table/itemtable.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports